// extracted by mini-css-extract-plugin
export default {"headerOrder":"headerOrder-module__headerOrder__S9tv-","label":"headerOrder-module__label__Y4XrP","description":"headerOrder-module__description__wu4UT"};